import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
  Select,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import APIKey from "../../image/api_key.png";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { ReactComponent as ArchiveButtonicon } from "../../image/ArchiveButtonicon.svg";

import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { authUserData } from "../../utils/Helper";
import { confirmAlert } from "react-confirm-alert";

const CompanyOnboarding = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { Option } = Select;
  const { Search } = Input;
  const [selectedRow, setSelectedRow] = useState([]);
  const [loading, setLoading] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getcompanyList = async () => {
      setLoading(true);

      try {
        const params = {
          ...state, // existing state: page, pagesize, search, ordering
          fields:
            "id,company_name,company_contact_name,company_number,company_abn_no,company_email,status,company_street_address,company_note,company_type", // add the fields param
        };
        let apiResponse = await getRequest("company/", params);
        if (apiResponse?.data?.results?.success) {
          setCompanyList(apiResponse?.data?.results?.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_company_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getcompanyList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });

    form.setFieldsValue({ search: "" });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "company_email" && sortOrder === "ascend") {
      sortingEnumKey = "company_email";
    }
    if (sortField === "company_email" && sortOrder === "descend") {
      sortingEnumKey = "-company_email";
    }

    if (sortField === "company_street_address" && sortOrder === "ascend") {
      sortingEnumKey = "company_street_address";
    }
    if (sortField === "company_street_address" && sortOrder === "descend") {
      sortingEnumKey = "-company_street_address";
    }

    if (sortField === "company_number" && sortOrder === "ascend") {
      sortingEnumKey = "company_number";
    }
    if (sortField === "company_number" && sortOrder === "descend") {
      sortingEnumKey = "-company_number";
    }

    if (sortField === "company_contact_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_contact_name";
    }
    if (sortField === "company_contact_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_contact_name";
    }

    if (sortField === "company_abn_no" && sortOrder === "ascend") {
      sortingEnumKey = "company_abn_no";
    }
    if (sortField === "company_abn_no" && sortOrder === "descend") {
      sortingEnumKey = "-company_abn_no";
    }
    if (sortField === "company_note" && sortOrder === "ascend") {
      sortingEnumKey = "company_note";
    }
    if (sortField === "company_note" && sortOrder === "descend") {
      sortingEnumKey = "-company_note";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }

    return sortingEnumKey;
  };

  const handleStatus = async (user_id, status) => {
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("pop_company_status_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(user_id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => navigate("/company-onboarding"),
        },
      ],
    });
  };

  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`company-status-change/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload((reload) => !reload);
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleGenerateAPIKey = async (id) => {
    try {
      setLoading(true);
      const payload = {
        company_id: id,
      };
      let response;
      response = await postRequest(
        `generate-secret-key/get-company-api-key/`,
        payload
      );
      if (response.data.success) {
        SuccessNotificationMsg(t("API Key Sent to your email"));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const [checkedList, setCheckedList] = useState([
    "company_name",
    "company_email",
    "company_street_address",
    "company_number",
    "company_contact_name",
    "company_abn_no",
    "company_note",
    "operation",
    "status",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
      width: 100,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "none",
          }}
        >
          {dataIndex}
        </div>
      ),
    },

    {
      title: "E-mail",
      dataIndex: "company_email",
      key: "company_email",
      sorter: true,
      width: 200,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   // title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        //   title={
        //     <span style={{ color: "#fff" }}>{dataIndex.toLowerCase()}</span>
        //   }
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textTransform: "lowercase",
          }}
        >
          {dataIndex.toLowerCase()}
        </div>
        // </Tooltip>
      ),
    },
    {
      title: "Address",
      dataIndex: "company_street_address",
      key: "company_street_address",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Contact Number",
      dataIndex: "company_number",
      key: "company_number",
      width: 180,
      render: (phone) => {
        if (phone) {
          const cleanedPhone = String(phone).replace(/\D/g, "");

          if (cleanedPhone.startsWith("91")) {
            return `+91 ${cleanedPhone.slice(2, 7)} ${cleanedPhone.slice(7)}`;
          } else if (cleanedPhone.length > 5) {
            const countryCode = cleanedPhone.slice(0, cleanedPhone.length - 10);
            const localNumber = cleanedPhone.slice(-10);
            return `+${countryCode} ${localNumber.slice(
              0,
              5
            )} ${localNumber.slice(5)}`;
          } else {
            return `+${cleanedPhone}`;
          }
        }
        return null;
      },

      sorter: true,
    },
    {
      title: "Contact Name",
      dataIndex: "company_contact_name",
      key: "company_contact_name",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
      ),
    },
    {
      title: "ABN Number",
      dataIndex: "company_abn_no",
      key: "company_abn_no",
      sorter: true,
      width: 130,
    },

    {
      title: "Note",
      dataIndex: "company_note",
      key: "company_note",
      sorter: true,
      width: 130,
      render: (dataIndex) => (
        // <Tooltip
        //   color={colors}
        //   placement="left"
        //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
        // >
        <div
          style={{
            maxWidth: "400px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {dataIndex}
        </div>
        // </Tooltip>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // fixed: "right",
      width: 250,
      render: (e, record) => (
        <div className="SelectStatusSec">
          <Select
            // value={e ? e : record.status}
            //onChange={(e) => handleStatus(record.id, e)}
            defaultValue={e}
            value={e ? e : record.status}
            onChange={(e) => handleStatus(record.id, e)}
          >
            <Option value="Pending" disabled>
              {" "}
              <div className="discardopt">{t("pending")}</div>
            </Option>
            <Option value="Active">
              {" "}
              <div className="dealdoneopt">{t("active")}</div>
            </Option>
            <Option value="Inactive">
              {" "}
              <div className="contactedopt">{t("inactive")}</div>
            </Option>
          </Select>
        </div>
      ),
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="left"
            title={<span style={{ color: "#fff" }}>Edit</span>}
          > */}
          {authUserData()?.permission.includes("company|change_company") && (
            <Link
              to={{
                pathname: "/company/edit/" + btoa(record.id),
              }}
            >
              <Editicon onClick={() => handleEdit(record.id)} />
            </Link>
          )}
          {/* </Tooltip> */}
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Archive</span>}
          > */}
          {authUserData()?.permission.includes("company|delete_company") && (
            <Popconfirm
              className="action"
              title={t("pop_title")}
              okText={t("pop_ok")}
              cancelText={t("pop_cancel")}
              onConfirm={() => handleArchive(record.id)}
            >
              <Archive style={{ cursor: "pointer" }} />
            </Popconfirm>
          )}
          {/* </Tooltip> */}
          {record?.status === "Active" ? (
            <>
              {/* <Tooltip
                color={colors}
                placement="right"
                title={<span style={{ color: "#fff" }}>Generate API Key</span>}
              > */}
              {authUserData()?.permission.includes(
                "company|change_company"
              ) && (
                <Popconfirm
                  className="action"
                  title={t("pop_title_api_key")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  onConfirm={() => handleGenerateAPIKey(record?.id)}
                >
                  <img
                    src={APIKey}
                    alt="APIKey"
                    width={30}
                    style={{ cursor: "pointer" }}
                  />
                </Popconfirm>
              )}
              {/* </Tooltip> */}
            </>
          ) : (
            ""
          )}
        </Space>
      ),
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  // const columnMenu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           <Col span={12}>
  //             <Checkbox value="company_name">Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_email">E-mail</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_street_address">Address</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_number">Contact Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_contact_name">Contact Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_abn_no">ABN Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="company_note">Note</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="status">Status</Checkbox>
  //           </Col>

  //           <Col span={12}>
  //             <Checkbox value="operation" disabled>
  //               Action
  //             </Checkbox>
  //           </Col>
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );

  const allColumns = [
    { key: "company_name", title: "Name" },
    { key: "company_email", title: "E-mail" },
    { key: "company_street_address", title: "Address" },
    { key: "company_number", title: "Contact Number" },
    { key: "company_contact_name", title: "Contact Name" },
    { key: "company_abn_no", title: "ABN Number" },
    { key: "company_note", title: "Note" },
    { key: "status", title: "Status" },
    { key: "operation", title: "Action" },
  ];

  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const handleArchive = async (id = []) => {
    // let ids = selectedRow;
    // if (ids.length === 0) {
    //   ids.push(id);
    // }
    let ids = [...selectedRow];
    if (ids.length === 0 && id) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("company/archive-company/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - ids.length;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("company_archive_successfully"));

        setSelectedRow([]);
      } else {
        setState((prevState) => ({
          ...prevState,
          page: 1,
          search: "",
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };

  const handleEdit = (id) => {};

  const colors = ["#737373"];
  return (
    <>
    <div className="mainwrapper">
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & manage the list of company within the organization.
                </span>
              }
            > */}
            <h3>{t("Manage Companies")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Manage Companies")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  Add A New Company To The Organization&apos;s Database.
                </span>
              }
            > */}
            {authUserData()?.permission.includes("company|add_company") && (
              <Button
                className="BlueShadowBtn"
                type="primary"
                onClick={() => navigate("/company/add")}
                icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
              >
                {t("Add Company")}
              </Button>
            )}
            {/* </Tooltip> */}

            {authUserData()?.permission.includes("company|delete_company") && (
              <>
                {selectedRow.length > 0 && (
                  <Popconfirm
                    className="action"
                    title={t("pop_title")}
                    okText={t("pop_ok")}
                    cancelText={t("pop_cancel")}
                    placement="left"
                    onConfirm={() => handleArchive()}
                  >
                    <ButtonField
                      className="BlueShadowBtn"
                      type="primary"
                      htmlType="button"
                      label={
                        <>
                          <div
                            className="BlueShadowBtn"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <ArchiveButtonicon />
                            <span>{t("pl_archive")}</span>
                          </div>
                        </>
                      }
                    />
                  </Popconfirm>
                )}
              </>
            )}
            {authUserData()?.permission.includes("company|delete_company") && (
              // <Tooltip placement="topLeft" title="View Archived Records">
              <Link className="Archiveicon" to="/company/archive">
                <Archiveicon />
              </Link>
              // </Tooltip>
            )}
            {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
            <div className="gridiconswrap">
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
            </div>
            {/* </Tooltip> */}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="tablewrp">
          <Table
            rowSelection={rowSelection}
            columns={columns.filter((col) => !col.hidden)}
            rowKey={(record) => record.id}
            dataSource={companyList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
            scroll={{
              x: 1000,
            }}
          />
          </div>
        </div>
      </section>
      </div>
    </>
  );
};
export default CompanyOnboarding;
